import { render, staticRenderFns } from "./NavMenuOccasions.vue?vue&type=template&id=5fd68825&scoped=true"
import script from "./NavMenuOccasions.vue?vue&type=script&lang=js"
export * from "./NavMenuOccasions.vue?vue&type=script&lang=js"
import style0 from "./NavMenuOccasions.vue?vue&type=style&index=0&id=5fd68825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd68825",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VList,VListItem,VTextField})
